/**
 * Why choose us: layout is CSS-only (no carousel).
 * File kept so block JS handle still loads theme localizations if needed.
 */
(function () {
  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      /* no-op */
    });
  }
})();
